export class UpdateUserCredit {
  static readonly type = '[Auth] Update User Credit';

  constructor(public newCredit: number) {
  }
}

